/**
 * @generated SignedSource<<3d98c5580a9a7a76ef601dde24ce6e16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemSearchExploreKeyAnglesItemArticleSearchResultStreamItemCategory$data = {
  readonly contents: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "entrySearchExploreKeyAnglesItemEntryContent" | "helpersExpertPerspectiveArticle">;
  } | null | undefined> | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "itemSearchExploreKeyAnglesItemArticleSearchResultStreamItemCategory";
};
export type itemSearchExploreKeyAnglesItemArticleSearchResultStreamItemCategory$key = {
  readonly " $data"?: itemSearchExploreKeyAnglesItemArticleSearchResultStreamItemCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemSearchExploreKeyAnglesItemArticleSearchResultStreamItemCategory">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemSearchExploreKeyAnglesItemArticleSearchResultStreamItemCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "contents",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersExpertPerspectiveArticle",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ArticleTypeSegment",
                  "kind": "LinkedField",
                  "name": "types",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ArticleType",
                      "kind": "LinkedField",
                      "name": "value",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Article",
              "abstractKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entrySearchExploreKeyAnglesItemEntryContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArticleSearchResultStreamItemCategory",
  "abstractKey": null
};
})();

(node as any).hash = "2bbe567ec70821392c880729745cb783";

export default node;
